<template>
  <div class="main-content-wrapper-footer">
    <div class="footer-bac">
      <img src="../../../../assets/images/footer-bac.png" style="width: 100%" />
    </div>
    <!--        <div class="mar-bot"></div>-->
    <div class="footer-border">
      <!-- <div class="footer-title">Follow Us</div> -->
      <div class="footer">
        <div class="footer-left">
          <div>
            <img src="../../../../assets/images/in.png" class="footer-img" @click="handleLeft1" />
          </div>
          <div class="left-img">
            <img src="../../../../assets/images/f.png" class="footer-img" @click="handleLeft2" />
          </div>
          <div class="left-img">
            <img src="../../../../assets/images/niao.png" class="footer-img" @click="handleLeft3" />
          </div>
          <div class="left-img">
            <img
              src="../../../../assets/images/play.png"
              class="footer-play"
              @click="handleLeft4"
            />
          </div>
        </div>

        <div class="shuxian-z"></div>

        <!--        <div class="footer-right">-->
        <div class="footer-right-text">
          <!--          todo底部切图   -->
          <div class="footer-right-logo" @click="handleLeft5">Privacy Statement</div>
          <div class="shuxian"></div>
          <div class="footer-right-logo" @click="handleLeft6">Home</div>
          <div class="shuxian"></div>
          <div class="footer-right-logo" @click="handleLeft7">Terms of Use</div>
          <div class="shuxian"></div>
          <div class="footer-right-logo" @click="handleLeft8">Contact Us</div>
        </div>

        <!--          <div class="footer-right-content">-->
        <!--            <img-->
        <!--              src="../../../../assets/images/share-footer.png"-->
        <!--              style="width: 80px; height: 80px"-->
        <!--            />-->
        <!--           没有分享至   -->
        <!--          </div>-->
        <!--        </div>-->
      </div>
    </div>
  </div>

  <div class="main-content-wrapper-copyright">
    <div class="overview-banner-copyright">
      <div class="copyright">
        <div class="copyright-left">
          Copyright ©New H3C Technologies Co., Ltd. All Rights Reserved.
        </div>
        <div class="copyright-right">
          <div class="icp">浙ICP备09064986号-1</div>
          <div class="copyright-img">
            <img src="../../../../assets/images/police.png" style="width: 20px; height: 20px" />
          </div>
          <div class="copyright-content">浙公网安备 33010802004416号</div>
        </div>
        <!--        <ul>-->
        <!--          <li><a href="https://www.h3c.com/cn/Home/Privacy_Clause/">隐私政策</a></li>-->
        <!--          <li><a href="https://www.h3c.com/cn/Home/Legal___Privacy/">版权声明</a></li>-->
        <!--          &lt;!&ndash;          <li><a href="/cn/Home/sitemap/">网站地图</a></li>&ndash;&gt;-->
        <!--          <li><a href="https://www.h3c.com/cn/About_H3C/Contact_Us/">联系我们</a></li>-->
        <!--        </ul>-->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  setup() {
    return {
      handleLeft1: () => {
        window.open('https://www.linkedin.com/company/h3c-technologies-co-ltd/', '_blank')
      },
      handleLeft2: () => {
        window.open('https://www.facebook.com/H3C-101713574763475/', '_blank')
      },
      handleLeft3: () => {
        window.open('https://twitter.com/H3CGlobal', '_blank')
      },
      handleLeft4: () => {
        window.open('https://www.youtube.com/channel/UC2NT0dk1z4Wb4zQjk1b6q1g/featured', '_blank')
      },
      handleLeft5: () => {
        window.open('https://www.h3c.com/en/Home/Privacy/', '_blank')
      },
      handleLeft6: () => {
        if (process.env.VUE_APP_MODE === 'production') {
          window.open('https://navigate.h3c.com/en/2023/pc/home', '_blank')
        } else {
          window.open('https://navigate-ts.h3c.com/en/2023/pc/home', '_blank')
        }
      },
      handleLeft7: () => {
        window.open('http://www.h3c.com/en/Home/TermsOfUse/', '_blank')
      },
      handleLeft8: () => {
        window.open('https://www.h3c.com/en/About_Us/Contact_Us/Offices/', '_blank')
      }
    }
  }
}
</script>

<style scoped lang="less">
.footer-border {
  width: 1200px; /* no-pxtorem */
  position: relative;
  padding: 10px 0;
  margin: 0 auto;
  /*border-style: solid;*/
  /* 布局后最底下的底纹再打开 */
  /* background: linear-gradient(to right, #ffffff 10%, #ffffff 0%); */

  /* 这个background不对，后续需要换成白色  */
  /*background: linear-gradient(to right, #070a11 100%, #0f1a4d 100%);*/
}
.overview-banner-copyright {
  width: 1200px;
  position: relative;
  height: 80px;
  margin: 0 auto;
  align-items: center;
}
.main-content-wrapper-footer {
  color: #ffffff;
  width: 100%;
  background-color: rgba(255, 255, 255, 0.15);
  height: 140px;
}
.main-content-wrapper-copyright {
  color: #ffffff;
  width: 100%;
  height: 80px;
  background: #000000;
  opacity: 1;
  position: relative;
}

.footer-bac {
  position: absolute;
  bottom: 0px;
  left: 0;
}
.footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 33px;
}
.footer-left {
  display: flex;
  padding-top: 10px;
}
.footer-right-text {
  font-size: 14px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.shuxian {
  width: 0px;
  height: 20px;
  opacity: 1;
  border: 1px solid rgba(255, 255, 255, 0.5);
  margin-right: 14px;
}
.shuxian-z {
  width: 0px;
  height: 40px;
  opacity: 1;
  border: 1px solid rgba(255, 255, 255, 0.5);
  //margin: 0px 67px;
}
//.footer-right {
//  font-size: 16px;
//  display: flex;
//  justify-content: space-between;
//}
.left-img {
  margin-left: 60px;
}
.footer-img {
  width: 48px;
  height: 48px;
  cursor: pointer;
}
.footer-play {
  width: 64px;
  height: 48px;
  cursor: pointer;
}
//.footer-left-content {
//  font-size: 20px;
//  font-weight: 400;
//  padding-right: 20px;
//}
.footer-right-logo {
  padding-right: 20px;
  cursor: pointer;
}
.copyright {
  display: flex;
  justify-content: center;
  font-size: 16px;
  align-items: center;
  height: 80px;
  ul {
    display: flex;
    margin: 0;
    li {
      padding: 0 10px;
      font-size: 14px;
      color: #666;
      border-right: 1px solid #666;
      a {
        color: #fff;
      }
    }
    li:last-child {
      border-right: 0;
    }
  }
}
.copyright-right {
  display: flex;
  justify-content: space-between;
  margin-left: 10px;
}
.icp {
  margin: 0 20px;
}
ul,
li {
  list-style: none;
}
.footer-title {
  font-size: 20px;
  //text-align: center;
  margin-right: 110px;
}
</style>
